module.exports = __webpack_public_path__ + "static/media/robo2.d8aa1174.png";